import GetAppIcon from '@material-ui/icons/GetApp'
import COLORS from '../../utils/constants/colors'

const DownloadIcon = ({ size, style, ...rest }) => (
  <GetAppIcon {...rest} fontSize={size || 'small'} style={style || { fill: COLORS.grey }} />
)

export default DownloadIcon
